import { SupabaseClient } from "@supabase/supabase-js";
import { 
  DEFAULT_PAYMENT_METHODS
} from "../../constants/defaultPaymentMethodContant";

export interface DefaultPaymentMethod {
  paymentMethodId: number;
  name: string;
  icon: string;
  isActive: boolean;
}


export const createDefaultPaymentMethods = async (
  organizationId: string,
  orgClient: SupabaseClient
): Promise<{ success: boolean; error?: any }> => {
  try {
    const paymentMethodsData = DEFAULT_PAYMENT_METHODS.map(method => ({
      name: method.name,
      icon: method.icon,
      is_active: method.isActive,
      organization_id: organizationId,
      default_payment_method_id: method.paymentMethodId,
    }));

    const { data, error } = await orgClient
      .from("payment_methods")
      .insert(paymentMethodsData)
      .select();

    if (error) {
      console.error("Error creating default payment methods:", error);
      return { success: false, error };
    }

    console.log("Default payment methods created successfully:", data);
    return { success: true };
  } catch (error) {
    console.error("Error in createDefaultPaymentMethods:", error);
    return { success: false, error };
  }
};
